import { render, staticRenderFns } from "./AddedBy.vue?vue&type=template&id=60287e4f&scoped=true&"
import script from "./AddedBy.vue?vue&type=script&lang=js&"
export * from "./AddedBy.vue?vue&type=script&lang=js&"
import style0 from "./AddedBy.vue?vue&type=style&index=0&id=60287e4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60287e4f",
  null
  
)

export default component.exports